<div class="scrollable">
  <app-cancernet-panel [drug]="explorerData.cancernetDrug" [(show)]="explorerData.showCancernetModal" (closeEvent)="explorerData.closeCancernetModal()"></app-cancernet-panel>
  <div class="content">
    <div class="container footer-padding">
      <div class="column is-8 is-offset-2">
        <div class="container has-text-centered">
          <img src="assets/caddie_logo.png" />
          <h2 class="subtitle is-3">Gene-Drug Interaction Lookup</h2>
        </div>
        <div class="content">
          <br />
          <div class="columns is-vcentered">
            <div class="column">
              <div class="field has-addons">
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Entrez or Uniprot AC..."
                    (keyup)="onKey($event)"
                  />
                </div>
                <div class="control">
                  <button
                    (click)="
                      lookGeneUp(searchString, selectedInteractionDrugDataset)
                    "
                    class="button is-info"
                    data-tooltip="Search for Entrez or Uniprot AC"
                  >
                    <span class="icon">
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </span>
                    <span>Search</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="column">
              <label
                class="has-text-right"
                data-tooltip="Select which daraset to use for gene-gene interactions"
              >
                Interaction Dataset:
              </label>
              <div class="field">
                <app-interaction-dataset-tile
                  [datasetItems]="interactionDrugDatasetItems"
                  [selectedDataset]="selectedInteractionDrugDataset"
                  (selectedDatasetChange)="
                    selectedInteractionDrugDataset = $event
                  "
                >
                </app-interaction-dataset-tile>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p-table
        *ngIf="searchResult != undefined && searchResult.gene"
        [value]="[searchResult.gene]"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Entrez</th>
            <th>UniProt Code</th>
            <th>Gene</th>
            <th>Protein Name</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-e>
          <tr>
            <td>
              <a
                href="https://www.ncbi.nlm.nih.gov/gene/?term={{ e.entrezId }}"
                target="_blank"
                >{{ e.entrezId }}</a
              >
            </td>
            <td>
              <a
                href="https://www.uniprot.org/uniprot/{{ e.uniprotAc }}"
                target="_blank"
                >{{ e.uniprotAc }}</a
              >
            </td>
            <td>{{ e.name }}</td>
            <td>{{ e.proteinName }}</td>
          </tr>
        </ng-template>
      </p-table>

      <br />
      <br />

      <div
        *ngIf="searchResult != undefined && searchResult.found"
        class="table-header"
      >
        <h4 class="is-4">
            <span class="icon"><i class="fa fa-disease"></i></span>
            <span>Cancer Types ({{ searchResult.cancerTypes.length }})</span>
        </h4>
      </div>
      <p-table
        *ngIf="searchResult != undefined && searchResult.cancerTypes.length"
        [value]="searchResult.cancerTypes"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Cancer Type</th>
            <th>Cancer Dataset</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-e>
          <tr>
            <td>
              {{ e.name }}
            </td>
            <td>
              {{ e.dataset }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <br />
      <br />

      <div
        *ngIf="searchResult != undefined && searchResult.found"
        class="table-header"
      >
        <h4 class="is-4">
          <span class="icon"><i class="fa fa-dna"></i></span>
          <span>Drugs ({{ searchResult.drugs.length }})</span>
        </h4>
        <a
          [href]="downloadLink('csv')"
          class="
            download
            button
            is-primary is-outlined is-pulled-right is-small
          "
        >
          <span class="icon"><i class="fa fa-download"></i></span>
          <span>Download</span>
        </a>
      </div>
      <p-table
        *ngIf="searchResult != undefined && searchResult.drugs.length > 0"
        [value]="searchResult.drugs"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>DrugBank ID</th>
            <th>Name</th>
            <th>Approved</th>
            <th [pSortableColumn]="'isNutraceutical'">
              Is Nutraceutical
              <p-sortIcon [field]="'isNutraceutical'"></p-sortIcon>
            </th>
            <th
              [pSortableColumn]="'isATCAntineoplasticAndImmunomodulatingAgent'"
              class="has-tooltip"
              data-tooltip="ATC Class L (Antineoplastic or Immunomodulating Agents)"
            >
              Antineoplastic or Immunomod.
              <p-sortIcon
                [field]="'isATCAntineoplasticAndImmunomodulatingAgent'"
              ></p-sortIcon>
            </th>
            <th>In Cancernet</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-e>
          <tr>
            <td>
              <a
                href="https://www.drugbank.ca/drugs/{{ e.dbId }}"
                target="_blank"
                >{{ e.dbId }}</a
              >
            </td>
            <td>
              {{ e.name }}
            </td>
            <td>
              <span *ngIf="e.status === 'approved'">
                <i class="fa fa-check"></i>
                Approved
              </span>
              <span *ngIf="e.status === 'unapproved'">
                <i class="fa fa-times"></i>
              </span>
            </td>
            <td>
              <span *ngIf="e.isNutraceutical">
                <i class="fa fa-leaf has-text-primary"></i>
                Nutraceutical
              </span>
              <span *ngIf="!e.isNutraceutical">
                <i class="fa fa-times"></i>
              </span>
            </td>
            <td>
              <span *ngIf="e.isAtcAntineoplasticAndImmunomodulatingAgent">
                <i class="fa fa-check has-text-primary"></i>
                Antineoplastic or Immunomodulating Agent
              </span>
              <span *ngIf="!e.isAtcAntineoplasticAndImmunomodulatingAgent">
                <i class="fa fa-times"></i>
              </span>
            </td>
            <td>
              <span *ngIf="e.inCancernet">
                <a (click)="explorerData.openCancernetModal(e)" >open<i class="fa fa-external-link has-text-primary"></i></a>
              </span>
              <span *ngIf="!e.inCancernet">
                <i class="fa fa-times"></i>
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
